import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import * as api from './api/index'
import ElementUI from 'element-ui';
import Vuex from 'vuex'
import Meta from 'vue-meta'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vant from 'vant';

import 'swiper/swiper-bundle.css'
import "./assets/css/animate.min.css";
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/icon/main/iconfont.css";
import "./assets/icon/share/iconfont.css";
import 'vant/lib/index.css';

Vue.config.productionTip = false
Vue.prototype.$https = 'http://cdn.fish-cloud.com/'

Vue.use(Vant);
Vue.use(Meta)
Vue.use(ElementUI);
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueAwesomeSwiper) /* { default options with global component } */

Vue.prototype.$date = function (month) {//日期转换指定字符串
  const arr = ['Jan', "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  let real = month.slice(0, 10)
  let a = real.split('-')//字符串拆分
  let b = Number(a[1])//月份转数字格式
  let c = arr[b - 1]//找月份所对应英文
  let str = `${a[2]} ${c} ${a[0]}`//拼接月份-日期-年份
  // console.log(str)
  return str
}

Vue.prototype.$google = function () {
  const url = window.location.href
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());

  gtag('config', 'G-9R8JLBGY7Z');
  var callback = function () {
    if (typeof (url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
    'send_to': 'AW-335487415/B-CWCPmCu9YCELfD_J8B',
    'event_callback': callback
  });
  return false;
}
Vue.prototype.formCheck = (form, type) => {//表单格式判断,type1：产品询盘，2：联系询盘
  // console.log(form)
  let num = 0, is_ok = false, is_empty = true, email_ok = false
  switch (type) {//判断是否空值
    case 1:
      if (form.name != '' && form.email != '' && form.VerifyCode != '' && form.message != '') {
        num += 1
        is_empty = false
      }
      break;
    case 2:
      if (form.name != '' && form.email != '' && form.message != '') {
        num += 1
        is_empty = false
      }
      break;
  }
  //邮箱格式判断
  const str = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  if (str.test(form.email) == true) {
    num += 1
    email_ok = true
  }
  if (num >= 2 && is_empty == false) {
    is_ok = true
  }
  // console.log(is_ok,num)
  return { is_ok: is_ok, is_empty: is_empty, email_ok: email_ok }
}

export default api

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
